import { Component, OnInit, OnDestroy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil, map} from 'rxjs/operators';

import { ApplicationService, Select, NomineeTypeInfo } from 'services/application/application.service';
import { AwardsService, AwardProgramInfo } from 'services/awards/awards.service';
import { ErrorService } from 'services/error/error.service';
import { UserService, UserInfo } from 'services/user/user.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { BaseSelectBoxSelectionOption } from 'services/dialogs/selectbox/selectbox.dialogcomponent';
import { SplashService } from 'services/splash/splash.service';
import { SettingsService } from 'services/settings/settings.service';

@Component({
  selector: 'app-devtools',
  templateUrl: './devtools.component.html',
  styleUrls: ['./devtools.component.scss']
})

export class DevToolsComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();

    User: UserInfo;
    AwardInfo: AwardProgramInfo;
	NomTypes: Select[];
	SchoolYear: string;

    constructor(
        private appSvc: ApplicationService,
        private awardSvc: AwardsService,
        private errSvc: ErrorService,
        private userSvc: UserService,
        private dlgSvc: DialogService,
		private splashSvc: SplashService,
		private settingsSvc: SettingsService
    ) { }

    ngOnInit() {
        this.userSvc.UserSubject.pipe(
            takeUntil(this._subrelease)
        ).subscribe(user => {
            this.User = user;

            let award$ = this.awardSvc.CurrentAwardsSub;
			let allNomTypes$ = this.appSvc.GetNomineeTypes();
			let schoolYear$ = this.settingsSvc.CurrentSchoolYearSubject;

			combineLatest(award$, allNomTypes$, schoolYear$).pipe(
                takeUntil(this._subrelease),
                map(_pck => {
                    return {
                        _Award: _pck[0],
						_AllNomineeTypes: _pck[1],
						_SchoolYear: _pck[2]
                    };
                })
            ).subscribe(packet => {
				this.AwardInfo = packet._Award;
				let allNomTypes: NomineeTypeInfo[] = packet._AllNomineeTypes;
				this.SchoolYear = packet._SchoolYear;
                this.NomTypes = allNomTypes.filter(f => f.AwardID === this.AwardInfo.AwardID).map(m => { return <Select>{ Value: m.NomineeTypeID, Display: m.Description } });
            },
            error => this.errSvc.HandleServiceError(error));
        },
        error => this.errSvc.HandleServiceError(error));
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    JudgeTool(processNumber: number) {
        this.dlgSvc.OpenSelectBoxDialog({
            Options: this.NomTypes.map(m => { return <BaseSelectBoxSelectionOption>{ Text: m.Display, Value: m.Value } }),
            TitleText: 'Choose which nomination you wish to run this process on'
        }).pipe(takeUntil(this._subrelease)).subscribe(choice => {
            if (choice != null) {
                this.appSvc.DevJudgingReset(
                    this.User.AuthToken,
                    this.User.CurrentRole,
                    this.AwardInfo.AwardID,
                    choice,
					processNumber,
					this.SchoolYear
                ).pipe(takeUntil(this._subrelease)).subscribe(res => {
                    this.splashSvc.CloseSplash();
                    this.splashSvc.SnackbarSuccess('Process ran successfully');
                },
                error => this.errSvc.HandleServiceError(error));
            }
        });
    }

}
